import React from "react"
import { Layout } from '../layout'
export default function Contact() {
  return <Layout><div>Contact world!</div></Layout>
}
